module.exports = __webpack_public_path__ + "img/header.ac04fa63.svg";